




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Activity } from '@/Activity'
import * as utils from '@/utils';
import * as utils_time from '@/utils_time';
import * as utils_topshot from '@/utils_topshot';

@Component({
  name: 'ActivityListComponent',
  components: { }
})
export default class ActivityListComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: null })
  public activity: Activity

  @Prop({ default: 0 })
  public index: number                 // in case it's ever useful for us to know where we are in the main list

  // public reactive member variables available to the html template

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public getNiceDecimalPriceString(number): string { return utils_topshot.getNiceDecimalPriceString(number)}

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
